import { IFormsyDecorator, withFormsy } from "formsy-react";
import * as React from "react";

interface Props extends IFormsyDecorator {
  placeholder?: string;
  type?: string;
  name: string;
  disabled?: boolean;
  onValidInput?(value: string): void;
  adjustValue?(value: string): string;
  multiline?: boolean;
  rows?: number;
  skipFirstInput: boolean;
  min?: string | number;
  max?: string | number;
  onChange?: (value: string) => void;
}

interface State {
  firstInput: boolean;
}

class Input extends React.Component<Props, State> {
  public static defaultProps: Partial<Props> = {
    type: "text",
    multiline: false,
  };
  state = {
    firstInput: true,
  };

  render() {
    const errorMessage =
      this.state.firstInput && this.props.skipFirstInput != true
        ? ""
        : this.props.getErrorMessage();
    const element = this.props.multiline ? (
      <textarea
        name={this.props.name}
        onBlur={this.onBlur}
        value={this.props.getValue()}
        onChange={this.handleChange}
        placeholder={this.props.placeholder}
        className={
          "form-control text-left " +
          (this.props.isValid()
            ? "valid"
            : this.state.firstInput && this.props.skipFirstInput != true
            ? ""
            : "invalid")
        }
        disabled={this.props.disabled}
        rows={this.props.rows}
      />
    ) : (
      <input
        name={this.props.name}
        onBlur={this.onBlur}
        value={this.props.getValue()}
        onChange={this.handleChange}
        placeholder={this.props.placeholder}
        className={
          "form-control " +
          (this.props.isValid()
            ? "valid"
            : this.state.firstInput && this.props.skipFirstInput != true
            ? ""
            : "invalid")
        }
        type={this.props.type}
        disabled={this.props.disabled}
        min={this.props.min}
        max={this.props.max}
      />
    );
    return (
      <React.Fragment>
        {element}
        <span className="invalid">
          <span>{errorMessage}</span>
        </span>
      </React.Fragment>
    );
  }

  handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let value = event.currentTarget.value;
    if (this.props.adjustValue) {
      value = this.props.adjustValue(value);
    }
    this.props.setValue(value);
    this.props.onChange?.(value);
    if (this.props.onValidInput && this.props.isValidValue(value)) {
      this.props.onValidInput(value);
    }
  };

  public validate = () => {
    this.setState({ firstInput: false });
  };

  onBlur = () => {
    if (this.props.getValue()) {
      this.setState({ firstInput: false });
    }
  };
}

export default withFormsy(Input);
